import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component, OnDestroy } from '@angular/core';


@Component({
    selector: 'btn-cell-renderer-details-delete-edit-clipboard',
    template: `
		<em>
			<div class="info-btn">
				<i *ngIf="enableDetails" title="Details" class="fas fa-info custom-icon-i"  (click)="btnClickedHandler('details')"></i>
			</div>
		</em>`,
	styles: [`
        .info-btn{
            display: flex;
            gap: 0.8rem;
            color: #fff;
            cursor: pointer;
        }

		::ng-deep .custom-icon-i {
			border: 1px solid #676A6E;
			padding: 4px 4px 4px 4px;
			cursor: pointer;
			background: transparent linear-gradient(180deg, #ffffff 0%, #e9f0f3 100%) 0% 0% no-repeat padding-box;
			opacity: 1;
			font: normal normal bold 10px;
			color: #676a6e;
			display: inline-flex;
    		justify-content: center;
    		width: 20px;
		}
    `],
    standalone: false
})
export class BtnCellRendererDetails implements ICellRendererAngularComp, OnDestroy {



	refresh(params: ICellRendererParams): boolean {
		throw new Error(`Error while refreshing renderer component. INFO-${params}`);
	}

	private params: any;
	pageName;
	enableDetails: boolean = false;
	enableDelete: boolean = false;
	enableEdit: boolean = false;

	agInit(params: any): void {
		this.params = params;
		this.pageName = this.params.colDef.field

		//shipments
		if (this.params.colDef.field == "details") {  // NOSONAR
			this.enableDetails = true;
			this.enableEdit = true;
			this.enableDelete = true;
		}

	}

	btnClickedHandler(action) {

		if (action == 'details') {  // NOSONAR
			this.params.context.componentParent.detailsTemplateRow(this.params.data, this.pageName);

		}

	}

	ngOnDestroy() {
		// do nothing 
	}
}
